export const ENVIRONMENT_SHARED = {
    discord_url: "https://discord.gg/e9bEhkChcS",
    facebook_url: "https://www.facebook.com/verygames",
    twitter_url: "https://twitter.com/VeryGames",
    instagram_url: "https://www.instagram.com/verygames_host",
    company_label: 'verygames',
}